const publicRoutes = [
  "/account-portal/references/",
  "/account-portal/education-references/",
  "/account-portal/backendTest"
];

const isPublicRoute = () => {
  const location = window.location.pathname;
  return publicRoutes.filter(route => location.startsWith(route)).length > 0;
};

export default isPublicRoute;
